import { booleanAttribute, ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DsBoxModule, DsButtonModule, DsMessageModule, DsTooltipDirectiveModule } from '@bmw-ds/components';

import { CustomerContactLineComponent } from '../../../../../customer/components/customer-contact-line/customer-contact-line.component';
import { PersonalIdentificationNumbersComponent } from '../../../../../customer/components/personal-identification-numbers/personal-identification-numbers.component';
import { CustomerContact } from '../../../../../customer/model/customer-information.model';
import { FoundCustomer } from '../../../../../customer/model/found-customer.model';
import { CustomerService } from '../../../../../customer/services/customer.service';
import { useI18n } from '../../../../../i18n/services/i18n.service';
import { CustomerVehicleRelationsComponent } from '../../../../../vehicle/components/customer-vehicle-relations/customer-vehicle-relations.component';

@Component({
  selector: 'cdf-search-result-line',
  imports: [
    DsBoxModule,
    DsButtonModule,
    CustomerContactLineComponent,
    DsTooltipDirectiveModule,
    DsMessageModule,
    CustomerVehicleRelationsComponent,
    PersonalIdentificationNumbersComponent,
  ],
  host: { '[class.box]': 'box()' },
  template: `
    <div class="name-section">
      <cdf-customer-vehicle-relations [relationTypes]="customer().customerToVehicleRelations" />
      <h2>{{ fullName() }}</h2>
      <cdf-personal-identification-numbers
        [taxNumber]="customer().taxNumber"
        [nationalId1]="customer().nationalId1"
        [nationalId1DocumentType]="customer().nationalId1DocumentType"
      />
    </div>
    <cdf-customer-contact-line [contact]="preferredContact()" showBmwMiniId singlePhone />
  `,
  styleUrl: './search-result-line.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultLineComponent {
  protected readonly customerService = inject(CustomerService);
  protected readonly i18n = useI18n();

  readonly customer = input.required<FoundCustomer>();

  readonly fullName = computed(() => this.customerService.fullName(this.customer()));

  protected readonly preferredContact = computed<CustomerContact>(() => ({
    address: this.customer().address,
    email: this.customer().email,
    phone: this.customer().phone,
    mobile: this.customer().mobile,
    bmwMiniId: this.customer().bmwMiniId,
  }));

  readonly box = input(false, { transform: booleanAttribute });
}
